// Globals
import { useEffect } from 'react';

// Store
import { useAppDispatch, useAppState } from '@/store';
import {
  getPaymentMethods,
  selectPaymentMethods,
  selectPaymentMethodsError,
  selectPaymentMethodsIsLoading,
} from '../feature';

export const useGetPaymentMethods = (channelId?: number) => {
  const paymentMethods = useAppState(selectPaymentMethods);
  const isLoading = useAppState(selectPaymentMethodsIsLoading);
  const error = useAppState(selectPaymentMethodsError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelId || !!paymentMethods || isLoading || !!error) return;
    dispatch(getPaymentMethods({ channelId }));
  }, [paymentMethods, channelId, isLoading, error, dispatch]);

  return {
    paymentMethods,
    isLoading,
    error,
  };
};
